export default function todoActions(dispatch) {
  function navigate(payload) {
    dispatch({
      type: "NAVIGATE",
      payload
    });
  }
  function setCurrentLevel(payload) {
    dispatch({
      type: "SET_CURRENT_LEVEL",
      payload
    });
  }
  function setArenaResult(arenaIndex, result) {
    dispatch({
      type: "SET_ARENA_RESULT",
      payload: { arenaIndex, result }
    });
  }
  function setShowEnding(state) {
    dispatch({
      type: "SET_SHOW_ENDING",
      payload: state
    });
  }
  function showOverlay(currentOverlayName) {
    dispatch({
      type: "SET_OVERLAY",
      payload: currentOverlayName
    });
  }
  function updateStateFromStorage(state) {
    dispatch({
      type: 'UPDATE_STATE_FROM_STORAGE',
      payload: state
    })
  }
  function updateStoredProgress(arenas) {
    dispatch({
      type: 'UPDATE_STORED_PROGRESS',
      payload: arenas
    })
  }

  return {
    navigate,
    setCurrentLevel,
    setArenaResult,
    showOverlay,
    updateStoredProgress,
    updateStateFromStorage,
    setShowEnding,
  }
}
